import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        content: {
            type: String,
            default: null
        },
        logo: {
            type: Object,
            default: null
        },
        playbutton: {
            type: Boolean,
            default: false
        }
    }
});
